import moment from 'moment-timezone';

import { timezoneLabels } from './timezoneLabels';

// Returns GMT offset string of timezone
// e.g. "GMT-7.5"
const timezoneOffset = (tz) => {
  const minutes = moment.tz.zone(tz).utcOffset(moment());
  const positiveOffset = minutes < 0; // Moment reports offsets with inverted +/-

  let remainderMinutes = Math.abs(minutes) % 60;
  if (remainderMinutes < 10) remainderMinutes = `0${remainderMinutes}`;
  const hours = Math.floor(Math.abs(parseFloat(minutes) / 60)).toString();

  return `GMT${positiveOffset ? '+' : '-'}${hours}:${remainderMinutes}`;
};

const timezoneData = (identifier, label) => {
  return {
    identifier,
    value: identifier,
    label: `(${timezoneOffset(identifier)}) ${label}`,
    name: label,
    offset: moment.tz.zone(identifier).parse(moment()),
    code: moment.tz(moment(), identifier).zoneAbbr(),
  };
};

// Returns full list of timezones
// X:1 identifier:label
export const timezoneList = timezoneLabels.reduce(
  (accumulator, { identifiers, label }) => {
    identifiers.forEach((identifier) => {
      accumulator[identifier] = timezoneData(identifier, label);
    });

    return accumulator;
  },
  {}
);

// Returns shortened list of timezones
// 1:1 identifier:label
export const condensedTimezoneList = timezoneLabels.reduce(
  (accumulator, { identifiers, label }) => {
    const identifier = identifiers[0];
    accumulator[identifier] = timezoneData(identifier, label);

    return accumulator;
  },
  {}
);
